import React, { useEffect, useRef } from "react";

function Agamographe({ right, left, n = 5, onClick }) {
    const canvas = document.createElement("canvas");
    canvas.width = 2970;
    canvas.height = 2100;
    const ctx = canvas.getContext("2d");
    ctx.strokeStyle = "#aaaaaa";
    ctx.lineWidth = 2;
    const imageRef = useRef(null);

    const imgR = new Image();
    imgR.src = right;
    const imgL = new Image();
    imgL.src = left;

    const handleClick = (e) => {
        e.preventDefault();
        onClick(imageRef.current);
    };

    useEffect(() => {
        const lDest = canvas.width / (2 * n);
        const hDest = canvas.height;
        imgR.onload = function () {
            const lSrc = imgR.width / n;
            const hSrc = imgR.height;
            for (let i = 0; i <= n; i++) {
                ctx.drawImage(
                    imgR,
                    i * lSrc,
                    0,
                    lSrc,
                    hSrc,
                    (1 + 2 * i) * lDest,
                    0,
                    lDest,
                    hDest
                );
                ctx.strokeRect((1 + 2 * i) * lDest, 0, lDest, hDest);
            }
            imageRef.current.src = canvas.toDataURL("image/png");
        };
        imgL.onload = function () {
            const lSrc = imgL.width / n;
            const hSrc = imgL.height;
            for (let i = 0; i <= n; i++) {
                ctx.drawImage(
                    imgL,
                    i * lSrc,
                    0,
                    lSrc,
                    hSrc,
                    2 * i * lDest,
                    0,
                    lDest,
                    hDest
                );
                ctx.strokeRect(2 * i * lDest, 0, lDest, hDest);
            }
            imageRef.current.src = canvas.toDataURL("image/png");
        };
    });

    return (
        <img
            ref={imageRef}
            className="w-100 pointer"
            title="Cliquer pour obtenir un pdf"
            onClick={handleClick}
        />
    );
}

export default Agamographe;
